import React, { useEffect, useState } from "react";
import LeftSection from "./left";
import RightSection from "./right";
import { useDispatch } from "react-redux";
// import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { login, logout } from "../../store/authSlice";
import artBoardBG from "../../images/artboard.png";

const dummySearchList = [
  {
    id: 1,
    title: "List Item 1",
    description: "Short Description 1",
    user: "demo",
    chatList: [
      {
        message: "hii",
        user: "demo",
      },
      {
        message: "hii",
        user: "you",
      },
    ],
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 2,
    title: "List Item 2 ",
    description: "Short Description 2",
    user: "demo12",
    chatList: [],
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 3,
    title: "List Item 3 ",
    description: "Short Description 3",
    user: "demo@125",
    chatList: [
      {
        message:
          "The top stories being discussed on Hacker News right now are:\n" +
          "\n" +
          "1. The unfortunate passing of Bram Moolenaar.[source]\n" +
          "2. A publication about successful room temperature ambient-pressure magnetic levitation of LK-99.[source]\n" +
          '3. A discussion on the best books read in 2022 with "The Dawn of Everything: A New History of Humanity" by Graeber and Wengrow being highlighted.[source]\n' +
          "\n" +
          "Please note the stories change frequently as the community upvotes new discussions.",
        user: "you",
      },
      {
        message: "hii",
        user: "demo@125",
      },
    ],
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 4,
    title: "List Item 4",
    description: "Short Description 4",
    user: "test@12",
    chatList: [],
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 5,
    title: "List Item 5",
    description: "Short Description 5",
    user: "test@87",
    chatList: [],
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 6,
    title: "List Item 6",
    description: "Short Description 6",
    user: "test",
    chatList: [],
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    startActive: false,
    children: [],
    isExpanded: false,
  },
];
const useQuery = (query) => {
  const [matches, setMatches] = useState(false);

  const handleChange = (e) => setMatches(e.matches);

  useEffect(() => {
    const m = window.matchMedia(query);

    setMatches(m.matches);

    m.addEventListener("change", handleChange);

    return () => {
      m.removeEventListener("change", handleChange);
    };
  }, [query]);

  return !matches;
};
const ChatPage = () => {
  const dispatch = useDispatch();
  const [user, ] = useState(null);
  const googleLogin = null;
  // useGoogleLogin({
  //   onSuccess: (codeResponse) => setUser(codeResponse),
  //   onError: (error) => console.log("Login Failed:", error),
  // });
  const isMobile = useQuery("(min-width: 768px)");
  const [userList, setUserList] = useState(dummySearchList);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [isCreatedNewChat, setIsCreatedNewChat] = useState(false);
  const deleteHandler = (isChildren, pId, cId) => {
    if (isChildren) {
      const clone = [...userList];
      const findIndex = clone?.findIndex((item) => item?.id === pId);
      if (findIndex !== -1) {
        clone[findIndex].children = clone[findIndex].children.filter(
          (item) => item?.id !== cId
        );
      }
      setUserList(clone);
    } else {
      const filterList = userList.filter((item) => item.id !== pId);
      if (selectedProfile?.id === pId) {
        setSelectedProfile(null);
      }
      setUserList(filterList);
    }
  };
  const searchHandler = (value) => {
    if (!value) {
      return setUserList(dummySearchList);
    }
    const filterList = userList.filter(
      (item) => item.title.toLowerCase().includes(value.toLowerCase()) && item
    );
    setUserList(filterList);
  };
  const starHandler = (isChildren, pId, cId) => {
    if (isChildren) {
      const clone = [...userList];
      const findUserIndex = clone?.findIndex((item) => item?.id === pId);

      if (findUserIndex !== -1) {
        const findChildUserIndex = clone[findUserIndex].children?.findIndex(
          (item) => item?.id === cId
        );
        if (findChildUserIndex !== -1) {
          clone[findUserIndex].children[findChildUserIndex].startActive =
            !clone[findUserIndex].children[findChildUserIndex]?.startActive;
        }
      }
      setUserList(clone);
    } else {
      const clone = [...userList];
      const findUserIndex = clone?.findIndex((item) => item?.id === pId);

      if (findUserIndex !== -1) {
        clone[findUserIndex].startActive = !clone[findUserIndex].startActive;
      }
      setUserList(clone);
    }
  };
  const expandedHandler = (id) => {
    const newValue = userList?.map((item) => {
      if (item.id === id) {
        return { ...item, isExpanded: !item.isExpanded };
      } else {
        return { ...item, isExpanded: false };
      }
    });
    setUserList(newValue);
  };
  const addChildHandler = (value) => {
    const newFolder = {
      id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
      title: value,
      description: "Short Description 6",
      user: "test",
      chatList: [],
      profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
        Math.random() * (50 - 1 + 1) + 1
      )}.jpg`,
      startActive: false,
      children: [
        {
          id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
          title: `List Item ${Math.floor(Math.random() * (50 - 1 + 1) + 1)}`,
          description: `Short Description ${Math.floor(
            Math.random() * (50 - 1 + 1) + 1
          )}`,
          user: "test",
          chatList: [],
          profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
            Math.random() * (50 - 1 + 1) + 1
          )}.jpg`,
          startActive: false,
        },
        {
          id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
          title: `List Item ${Math.floor(Math.random() * (50 - 1 + 1) + 1)}`,
          description: `Short Description ${Math.floor(
            Math.random() * (50 - 1 + 1) + 1
          )}`,
          user: "test",
          chatList: [],
          profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
            Math.random() * (50 - 1 + 1) + 1
          )}.jpg`,
          startActive: false,
        },
        {
          id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
          title: `List Item ${Math.floor(Math.random() * (50 - 1 + 1) + 1)}`,
          description: `Short Description ${Math.floor(
            Math.random() * (50 - 1 + 1) + 1
          )}`,
          user: "test",
          chatList: [],
          profileUrl: `https://xsgames.co/randomusers/assets/avatars/female/${Math.floor(
            Math.random() * (50 - 1 + 1) + 1
          )}.jpg`,
          startActive: false,
        },
      ],
      isExpanded: false,
    };
    setUserList((pre) => [newFolder, ...pre]);
  };
  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          dispatch(login({ ...res.data, token: user?.access_token }));
        })
        .catch((err) => console.log(err));
    }
  }, [user, dispatch]);
  const logoutHandler = () => {
    dispatch(logout());
  };
  return (
    <div
      className={
        "h-screen flex flex-row w-full bg-no-repeat bg-cover bg-center"
      }
      style={{ backgroundImage: `url(${artBoardBG})` }}
    >
      {isMobile ? (
        !selectedProfile?.user &&
        !isCreatedNewChat && (
          <LeftSection
            selectedProfile={selectedProfile}
            userList={userList}
            setSelectedProfile={setSelectedProfile}
            deleteHandler={deleteHandler}
            searchHandler={searchHandler}
            starHandler={starHandler}
            expandedHandler={expandedHandler}
            addChildHandler={addChildHandler}
            googleLogin={googleLogin}
            isMobile={isMobile}
            logoutHandler={logoutHandler}
            setIsCreatedNewChat={setIsCreatedNewChat}
          />
        )
      ) : (
        <LeftSection
          selectedProfile={selectedProfile}
          userList={userList}
          setSelectedProfile={setSelectedProfile}
          deleteHandler={deleteHandler}
          searchHandler={searchHandler}
          starHandler={starHandler}
          expandedHandler={expandedHandler}
          addChildHandler={addChildHandler}
          setIsCreatedNewChat={setIsCreatedNewChat}
        />
      )}
      {isMobile ? (
        selectedProfile?.user && (
          <RightSection
            isMobile={isMobile}
            selectedProfile={selectedProfile}
            userList={userList}
            setSelectedProfile={setSelectedProfile}
            setUserList={setUserList}
            googleLogin={googleLogin}
            logoutHandler={logoutHandler}
            isCreatedNewChat={isCreatedNewChat}
            setIsCreatedNewChat={setIsCreatedNewChat}
          />
        )
      ) : (
        <RightSection
          selectedProfile={selectedProfile}
          userList={userList}
          setSelectedProfile={setSelectedProfile}
          setUserList={setUserList}
          googleLogin={googleLogin}
          logoutHandler={logoutHandler}
          isCreatedNewChat={isCreatedNewChat}
          setIsCreatedNewChat={setIsCreatedNewChat}
        />
      )}
      {isMobile && isCreatedNewChat && (
        <RightSection
          isMobile={isMobile}
          selectedProfile={selectedProfile}
          userList={userList}
          setSelectedProfile={setSelectedProfile}
          setUserList={setUserList}
          googleLogin={googleLogin}
          logoutHandler={logoutHandler}
          isCreatedNewChat={isCreatedNewChat}
          setIsCreatedNewChat={setIsCreatedNewChat}
        />
      )}
    </div>
  );
};
export default ChatPage;
